import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./hooks/useAuth";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import WritePost from "./pages/WritePost";
import BoardWrite from "./pages/BoardWrite";
import Register from "./pages/Register";
import Login from "./pages/Login";
import BusinessTutoring from "./pages/BusinessTutoring";
import BusinessTutoringWrite from "./pages/BusinessTutoringWrite";
import BusinessDetail from "./pages/BusinessDetail";
import TrainingDetail from "./pages/TrainingDetail";
import Travel from "./pages/Travel";
import RestaurantDetail from "./pages/RestaurantDetail";
import DestinationDetail from "./pages/DestinationDetail";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import BulletinBoard from "./pages/BulletinBoard";
import PostDetail from "./pages/PostDetail";
import EditPost from "./pages/EditPost";
import Profile from "./pages/Profile";
import SearchResults from "./pages/SearchResults";
import { SEO } from "./components/seo/SEO";
import WebhookPage from "./pages/Webhook";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <AuthProvider>
        <SEO /> {/* Default SEO settings */}
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/community/write" element={<WritePost />} />
            <Route path="/board/write" element={<BoardWrite />} />
            <Route path="/board/edit/:id" element={<EditPost />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />
            <Route path="/business-tutoring" element={<BusinessTutoring />} />
            <Route path="/business-tutoring/write" element={<BusinessTutoringWrite />} />
            <Route path="/business-tutoring/business/:id" element={<BusinessDetail />} />
            <Route path="/business-tutoring/training/:id" element={<TrainingDetail />} />
            <Route path="/travel" element={<Travel />} />
            <Route path="/restaurant/:id" element={<RestaurantDetail />} />
            <Route path="/destination/:id" element={<DestinationDetail />} />
            <Route path="/news" element={<News />} />
            <Route path="/news/:id" element={<NewsDetail />} />
            <Route path="/board" element={<BulletinBoard />} />
            <Route path="/board/post/:id" element={<PostDetail />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/search" element={<SearchResults />} />
            <Route path="/webhook" element={<WebhookPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
